// The token-authenticated account-setup pages (registration / password reset). One route pair
// serves clients and volunteers; the mode-level strings are subject-neutral (they render before
// the token context is loaded), the subject-specific sentences live under `client` / `volunteer`
// and are picked via the context's subject type.
export default {
  registration: {
    pageTitle: "Registrierung",
    submit: "Registrierung abschließen",
    successTitle: "Registrierung abgeschlossen",
    client: {
      intro:
        "Legen Sie ein Passwort fest, um Ihre Registrierung für das Kund:innen-Portal der Schuldenberatung Wien abzuschließen.",
      successBody: "Sie können sich ab sofort mit Ihrer E-Mail-Adresse und Ihrem Passwort anmelden.",
      rejectedError:
        "Die Registrierung konnte nicht abgeschlossen werden. Für diese E-Mail-Adresse existiert möglicherweise bereits ein Benutzerkonto — bitte wenden Sie sich an Ihre Beratung.",
    },
    volunteer: {
      intro:
        "Legen Sie ein Passwort fest, um Ihre Registrierung als ehrenamtliche/r Mitarbeiter/in der Schuldenberatung Wien abzuschließen.",
      successBody: "Sie können sich ab sofort mit Ihrem Kürzel oder Ihrer E-Mail-Adresse und Ihrem Passwort anmelden.",
      rejectedError:
        "Die Registrierung konnte nicht abgeschlossen werden. Für dieses Kürzel oder diese E-Mail-Adresse existiert möglicherweise bereits ein Benutzerkonto — bitte wenden Sie sich an die Schuldenberatung Wien.",
    },
  },
  passwordReset: {
    pageTitle: "Passwort zurücksetzen",
    submit: "Passwort speichern",
    successTitle: "Passwort geändert",
    client: {
      intro: "Legen Sie ein neues Passwort für das Kund:innen-Portal der Schuldenberatung Wien fest.",
      successBody: "Sie können sich ab sofort mit Ihrem neuen Passwort anmelden.",
      rejectedError:
        "Das Passwort konnte nicht gespeichert werden. Es darf nicht dem bisherigen Passwort entsprechen und muss den Passwort-Richtlinien genügen.",
    },
    volunteer: {
      intro: "Legen Sie ein neues Passwort für das Portal der Schuldenberatung Wien fest.",
      successBody: "Sie können sich ab sofort mit Ihrem neuen Passwort anmelden.",
      rejectedError:
        "Das Passwort konnte nicht gespeichert werden. Es darf nicht dem bisherigen Passwort entsprechen und muss den Passwort-Richtlinien genügen.",
    },
  },
  emailLabel: "E-Mail-Adresse",
  passwordLabel: "Passwort",
  passwordConfirmLabel: "Passwort bestätigen",
  passwordPolicyHint: "Mindestens {{minLength}} Zeichen, mindestens eine Ziffer und ein Sonderzeichen.",
  passwordRequired: "Bitte geben Sie ein Passwort ein.",
  passwordTooShort: "Das Passwort muss mindestens {{minLength}} Zeichen lang sein.",
  passwordNeedsDigit: "Das Passwort muss mindestens eine Ziffer enthalten.",
  passwordNeedsSpecialChar: "Das Passwort muss mindestens ein Sonderzeichen enthalten.",
  passwordInvalidCharacters: "Das Passwort enthält ungültige Zeichen.",
  passwordMismatch: "Die Passwörter stimmen nicht überein.",
  invalidLinkTitle: "Dieser Link ist nicht mehr gültig.",
  invalidLinkBody:
    "Der Link wurde bereits verwendet, ist abgelaufen oder wurde deaktiviert. Bitte wenden Sie sich an Ihre Beratung, um einen neuen Link zu erhalten.",
  checkingLink: "Link wird geprüft…",
  toLogin: "Zur Anmeldung",
  genericError: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
};
